import { isNative } from "./native.js";

/**
 * spec08 FR5: the Ronin server the app talks to. It is not a secret, so it lives in the
 * WebView's storage; the session token does not (tokens.ts).
 */
const KEY = "ronin.server";

/** The server origin in the app, "" in the browser (same origin). */
export function serverUrl(): string {
  if (!isNative) return "";
  try {
    return localStorage.getItem(KEY) ?? "";
  } catch {
    return "";
  }
}

export function setServerUrl(url: string) {
  localStorage.setItem(KEY, url);
}
